const STORAGE_KEY = 'viewedProducts';

class RecentlyViewedCarousel extends HTMLElement {
  connectedCallback() {
    this.#render();
  }

  async #render() {
    const ids = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const limit = parseInt(this.dataset.limit || '6', 10);
    const productIds = ids.slice(0, limit);

    if (productIds.length === 0) {
      this.dataset.empty = 'true';
      return;
    }

    const track = this.querySelector('[data-track]');
    if (!track) return;

    const params = new URLSearchParams({
      type: 'product',
      'options[prefix]': 'last',
      q: productIds.map((id) => `id:${id}`).join(' OR '),
    });

    try {
      const res = await fetch(`${this.dataset.url}?${params}&view=recently-viewed-cards`);
      if (!res.ok) {
        this.dataset.empty = 'true';
        return;
      }
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelector('.recently-viewed-cards');
      if (cards && cards.innerHTML.trim()) {
        track.innerHTML = cards.innerHTML;
      } else {
        await this.#renderViaSection(productIds, track);
      }
    } catch {
      await this.#renderViaSection(productIds, track);
    }
  }

  async #renderViaSection(productIds, track) {
    const cards = [];
    for (const id of productIds) {
      try {
        const res = await fetch(`/recommendations/products.json?product_id=${id}&limit=1`);
        if (!res.ok) continue;
        const data = await res.json();
        const p = data.products?.[0];
        if (!p) continue;
        const img = p.featured_image ? `<img class="recently-viewed-section__img" src="${p.featured_image}" alt="${p.title}" loading="lazy" width="160" height="160">` : '';
        const price = p.price ? (p.price / 100).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' }) : '';
        cards.push(`<a href="${p.url}" class="recently-viewed-section__card">${img}<span class="recently-viewed-section__title">${p.title}</span><span class="recently-viewed-section__price">${price}</span></a>`);
      } catch { /* skip */ }
    }
    if (cards.length === 0) {
      this.dataset.empty = 'true';
    } else {
      track.innerHTML = cards.join('');
    }
  }
}

if (!customElements.get('recently-viewed-carousel')) {
  customElements.define('recently-viewed-carousel', RecentlyViewedCarousel);
}
